// src/components/result/ShareBlock.js
import React from "react";
import html2canvas from "html2canvas";

// 점수 → 요약 문장용
const TRAIT_ORDER = ["E", "I", "S", "N", "T", "F", "P", "J"];

const TRAIT_SUMMARY_PART = {
  E: "사람 속에서 에너지를 얻고",
  I: "혼자 있을 때 에너지를 채우고",
  S: "눈앞의 현실과 실제 데이터를 중시하고",
  N: "아이디어와 가능성을 좇고",
  T: "논리와 기준으로 판단하고",
  F: "감정과 관계의 결을 신경 쓰고",
  P: "상황에 맞게 유연하게 반응하고",
  J: "계획과 마감을 챙기면서 움직이는",
};

function buildSummarySentenceForShare(scores) {
  const traits = TRAIT_ORDER.map((key) => ({ key, value: scores[key] ?? 0 }))
    .sort((a, b) => b.value - a.value)
    .slice(0, 3);

  const parts = traits.map((t) => TRAIT_SUMMARY_PART[t.key]).filter(Boolean);

  if (parts.length === 0) {
    return "이걸 종합해보면, 나는 어느 한쪽으로 확 치우치기보다는 상황 따라 모드가 달라지는 사람인 것 같아.";
  }

  let mid = "";
  if (parts.length === 1) {
    mid = parts[0];
  } else if (parts.length === 2) {
    mid = `${parts[0]}, ${parts[1]}`;
  } else {
    mid = `${parts[0]}, ${parts[1]}, 그리고 ${parts[2]}`;
  }

  // 공유용이라 2인칭(너) 말고 1인칭(나) 버전
  return `이걸 종합해보면, 나는 ${mid} 있어.`;
}

function buildShareText(scores) {
  const traits = ["E", "I", "S", "N", "T", "F", "P", "J"];

  const lines = traits.map((t) => `${t}: ${scores[t] ?? 0}점`).join(" · ");

  const summaryLine = buildSummarySentenceForShare(scores);

  return [
    "mmbbttii 성향 테스트 결과",
    "",
    summaryLine,
    "",
    lines,
    "",
    "진짜 나를 찾으려면 MBTI 네 글자만 붙들고 있지 말자.",
    "mmbbttii에서 여덟 가지 성향으로 나를 다시 보기.",
  ].join("\n");
}

function ShareBlock({ scores }) {
  const handleSaveImage = async () => {
    const card = document.getElementById("result-card-area");
    if (!card) {
      alert("결과 카드 영역을 찾을 수 없어요.");
      return;
    }

    try {
      const canvas = await html2canvas(card, {
        backgroundColor: "#050816", // 배경 색 통일
        scale: 2, // 조금 더 선명하게
      });
      const dataUrl = canvas.toDataURL("image/png");

      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "mmbbttii-result.png";
      link.click();
    } catch (e) {
      console.error(e);
      alert("이미지로 저장하는 데 실패했어요.");
    }
  };

  const handleCopy = async () => {
    try {
      const text = buildShareText(scores);
      await navigator.clipboard.writeText(text);
      alert("결과 요약을 클립보드에 복사했어요. 원하는 곳에 붙여넣기 하세요!");
    } catch (e) {
      alert("복사에 실패했어요. 브라우저 권한을 확인해 주세요.");
    }
  };

  const handleShare = async () => {
    const url = window.location.origin; // /result는 점수 유지 안 되니, 메인 도메인만
    const text =
      "나는 E/I/S/N/T/F/P/J 8가지 성향을 점수로 보는 mmbbttii 테스트를 해봤어요.";

    if (navigator.share) {
      try {
        await navigator.share({
          title: "mmbbttii 성향 테스트",
          text,
          url,
        });
      } catch {
        // 사용자가 취소한 경우 등은 무시
      }
    } else {
      // Web Share API가 없으면 복사 기능으로 대체
      handleCopy();
    }
  };

  return (
    <section className="result-section result-section-share">
      <h2 className="result-section-title">4. 이 결과, 한 번 뿌려볼래?</h2>
      <p className="result-body-text">
        캡처해도 좋고, 아래 버튼으로 결과를 이미지/텍스트로 저장해서 친구들에게
        보내도 좋아요.
      </p>

      <div className="result-share-actions">
        <button
          type="button"
          className="result-button"
          onClick={handleSaveImage}
        >
          결과를 이미지로 저장
        </button>

        <button
          type="button"
          className="result-button result-button--ghost"
          onClick={handleCopy}
        >
          결과 요약 텍스트 복사
        </button>

        <button
          type="button"
          className="result-button result-button--ghost"
          onClick={handleShare}
        >
          링크 공유하기
        </button>
      </div>
    </section>
  );
}

export default ShareBlock;
